import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import { ANALYTICS } from '@/constants/analytics/analytics';
import {
  GROUPED_BUCKETS,
  OPT_IN_PREFERENCE,
  OptInPreference,
} from '@/constants/features/opt-in';

export const usePermissionsAnalytics = () => {
  const { fireAnalyticsEvent } = useAnalytics();

  // One event per consent topic the action touched. Granting and revoking are
  // the two halves of the same signal, so both come through here — the modal
  // grants, the Settings toggles revoke.
  const firePermissionsEvents = (
    activationSource: string,
    buckets: OptInPreference[],
    isGranted: boolean
  ): void => {
    const fire = (eventType: string): void => {
      fireAnalyticsEvent(ANALYTICS.EVENTS.PERMISSIONS, {
        [ANALYTICS.PROPERTIES.EVENT_TYPE]: eventType,
        [ANALYTICS.PROPERTIES.ACTIVATION_SOURCE]: activationSource,
        [ANALYTICS.PROPERTIES.IS_GRANTED]: isGranted,
      });
    };

    if (buckets.includes(OPT_IN_PREFERENCE.CLICK_STREAM)) {
      fire(ANALYTICS.TYPES.OPT_IN);
    }
    if (GROUPED_BUCKETS.some(bucket => buckets.includes(bucket))) {
      fire(ANALYTICS.TYPES.OPT_IN_BUCKETS);
    }
    if (buckets.includes(OPT_IN_PREFERENCE.AI)) {
      fire(ANALYTICS.TYPES.OPT_IN_AI);
    }
  };

  return { firePermissionsEvents };
};
